import React, { useState } from 'react';
import { Linking, Platform } from 'react-native';
import { requiresAiSharingConsent } from '@/lib/appDistribution';
import { useAuthStore } from '@/store/auth';
import { useAiSharingConsent } from '@/store/aiSharingConsent';
import SettingsSection from '@/components/SettingsSection';
import Text from '@/components/Typography/Text';
import Button from '@/components/Buttons/Button';

export default function AiSharingSettings() {
  const accountId = useAuthStore(state => state.user?.id);
  const choose = useAiSharingConsent(state => state.choose);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  if (Platform.OS === 'ios') return <SettingsSection title="AI data sharing" subtitle="When you use AI, your prompts and relevant earlier messages, stored memories, attached files, Work content, and voice or camera media are shared with the provider handling your request, including personal information in that content. Auto and Work may choose a provider for you. Media requests may use other providers. Providers include OpenAI, Anthropic, Google and FAL. We don’t attach your email or account details.">
    <Button text="Privacy Policy" variant="secondary" onPress={async () => {
      setError('');
      try { await Linking.openURL('https://gab.ai/privacy-policy'); }
      catch (_) { setError('Unable to open this link. Please try again.'); }
    }} />
    {!!error && <Text color="danger" accessibilityRole="alert">{error}</Text>}
  </SettingsSection>;
  if (!requiresAiSharingConsent()) return null;
  return <SettingsSection title="AI data sharing" subtitle="You allowed prompts and relevant earlier messages, stored memories, attached files, Work content, and voice or camera media, including personal information in that content, to be shared with the AI providers handling your requests. Auto and Work may choose a provider for you. Turning this off blocks new requests on this device. Stop existing tasks and schedules separately.">
    <Button text="Turn off AI data sharing" variant="secondary" isDisabled={busy} onPress={async () => {
      setBusy(true); setError('');
      try {
        require('@/store/voiceMode').useVoiceModeStore.getState().actions.stopVoiceMode();
        await choose(accountId, false);
      } catch (_) { setError('Unable to save your choice. Please try again.'); }
      finally { setBusy(false); }
    }} />
    {!!error && <Text color="danger" accessibilityRole="alert">{error}</Text>}
  </SettingsSection>;
}
